export default __webpack_public_path__ + "static/media/experience2.8b2983d5.png";